import { render, staticRenderFns } from "./CreateProductModal.vue?vue&type=template&id=7a3531f6&scoped=true&"
import script from "./CreateProductModal.vue?vue&type=script&lang=ts&"
export * from "./CreateProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3531f6",
  null
  
)

export default component.exports